import { Component, OnInit, Input } from '@angular/core';
import { BookingOrderService } from '../../services/booking-order.service';
import { OrderLine } from '../../../order/models/order-line';
import { BookingStepService } from '../../services/booking-step.service';
import { AreaItem } from '../../models/area-item';
import { BookingProductStepService } from '../../services/booking-product-step.service';
import { BookingProductStepEnum } from '../../models/booking-product-step.enum';
import { Product } from 'src/app/modules/order/models/product';

@Component({
  selector: 'app-booking-product-configuration-page',
  templateUrl: './booking-product-configuration-page.component.html',
  styleUrls: ['./booking-product-configuration-page.component.css']
})
export class BookingProductConfigurationPageComponent implements OnInit {

  private _errorMessage = 'Please fill out the form!';
  quantity: number[];
  orderLines: OrderLine[];
  startPersonsNumbering = 0;
  private _areaItems: AreaItem[];
  private _isValidForwardButton = false;
  private _orderLinePartnerFormValidByIndex = Array<boolean>();
  private _products: Product[];

  constructor(
    private bookingOrderService: BookingOrderService,
    private bookingStepService: BookingStepService,
    private bookingProductStepService: BookingProductStepService,
  ) { }

  ngOnInit(): void {
    this._areaItems = this.bookingOrderService.areaItems;
    this._products = this.bookingProductStepService.products;
    const order = this.bookingOrderService.order;
    if (order && order.orderLines) {
      this.orderLines = order.orderLines;
    }
  }

  onBackwardClick(): void {
    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      this.bookingProductStepService.back();
      return;
    }

    this.bookingStepService.back();
  }

  onForwardClick(): void {
    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      this.bookingProductStepService.forward();
      return;
    }

    this.bookingStepService.forward();
  }

  get forwardError(): string {
    return this._isValidForwardButton ? '' : this._errorMessage;
  }

  udpateOrderLinePartnerFormState(isValid: boolean, orderLineIndex: number): void {
    if (orderLineIndex === undefined) {
      return;
    }
    this._orderLinePartnerFormValidByIndex[orderLineIndex] = isValid;
    this.updateStateShowForwardButton(orderLineIndex);
  }

  updateStateShowForwardButton(orderLineIndex: number): void {
    if (orderLineIndex === undefined || this._orderLinePartnerFormValidByIndex.length < orderLineIndex) {
      return;
    }
    this._isValidForwardButton = !this._orderLinePartnerFormValidByIndex.some(value => value === false);
  }

  isPartnerRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return;
    } 

    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      return this._valueRequiredPartnerFieldInProduct(orderLine.productId, 'isPartnerRequired');
    }

    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isPartnerRequired');
  }

  isBirthdayRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return;
    }

    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      return this._valueRequiredPartnerFieldInProduct(orderLine.productId, 'isBirthdayRequired');
    }

    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isBirthdayRequired');
  }

  isShow(orderLine: OrderLine): boolean {
    return this.isPartnerRequired(orderLine) ||
      this.isBirthdayRequired(orderLine) ||
      this.isPhoneRequired(orderLine) ||
      this.isAddressRequired(orderLine) ||
      this.isEmailRequired(orderLine);
  }

  updateStartPersonNumbering(startNumbering: number): void {
    if (startNumbering === undefined) {
      return;
    }
    this.startPersonsNumbering = startNumbering;
  }

  isPhoneRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }

    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      return this._valueRequiredPartnerFieldInProduct(orderLine.productId, 'isPhoneRequired');
    }

    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isPhoneRequired');
  }

  isAddressRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }

    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      return this._valueRequiredPartnerFieldInProduct(orderLine.productId, 'isAddressRequired');
    }

    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isAddressRequired');
  }

  isEmailRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }

    if (this.bookingProductStepService && this.bookingProductStepService.step == BookingProductStepEnum.ShowProductConfigurationPage) {
      return this._valueRequiredPartnerFieldInProduct(orderLine.productId, 'isEmailRequired');
    }

    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isEmailRequired');
  }

  private _valueRequiredPartnerFieldInAria(productId: number, field: string): boolean {
    if (!productId || !this._areaItems || this._areaItems.length === 0 || !field) {
      return false;
    }
    return this._areaItems.some(item => (item.productId === productId) && item[field]);
  }

  private _valueRequiredPartnerFieldInProduct(productId: number, field: string): boolean {
    if (!productId || !this._products || this._products.length === 0 || !field) {
      return false;
    }
    return this._products.some(item => (item.id === productId) && item[field]);
  }
}
